/*
	Copyright (c) 2022 PierceGearhart
    StellaNode Website

	Source code shall not be distributed or modified without
	prior permission from the copyright holder (PierceGearhart) or the
	client (StellaNode).
*/

import ReactDOMClient from 'react-dom/client'
import { Navigate, BrowserRouter, Routes, Route } from 'react-router-dom'
import reportWebVitals from './reportWebVitals'
import Scroll from './components/scroll'
import './index.css'
// System Routes
import Index from './system/index'
import Games from './system/games/index'
import Minecraft from './system/games/minecraft'
import BudgetMinecraftEU from './system/games/budgetminecraft'
import BudgetMinecraftNA from './system/games/budgetminecraftna'
import Other from './system/other/index'
import Discord from './system/other/discord'
import Web from './system/other/web'
import Partner from './system/partners'
import Jobs from './system/jobs'
import Tos from './system/legal/terms'
import Privacy from './system/legal/privacy'

const root = ReactDOMClient.createRoot(document.getElementById('app')!)

const PageNotFound = () => {
    return (
        <Navigate to='/' replace={true} />
    )
}

root.render(
    <BrowserRouter>
        <Scroll />
        <Routes>
            <Route path='/' element={<Index />} />
            <Route path='/games' element={<Games />} />
            <Route path='/games/minecraft-budget-eu' element={<BudgetMinecraftEU />} />
            <Route path='/games/minecraft-budget-na' element={<BudgetMinecraftNA />} />
            <Route path='/games/minecraft' element={<Minecraft />} />
            <Route path='/other' element={<Other />} />
            <Route path='/other/discord' element={<Discord />} />
            <Route path='/other/web' element={<Web />} />
            <Route path='/partners' element={<Partner />} />
            <Route path='/jobs' element={<Jobs />} />
            <Route path='/terms' element={<Tos />} />
            <Route path='/privacy' element={<Privacy />} />
            <Route path='*' element={<PageNotFound />} />
        </Routes>
    </BrowserRouter>
)

reportWebVitals()